const CurrentDietConfigMealSlot = (json: ICurrentDietConfigMealSlot): ICurrentDietConfigMealSlotModel => {
	const { meal_type, size_id } = json
	return {
		mealType: meal_type,
		sizeID: size_id,
	}
}

export const CurrentDietConfig = (json: ICurrentDietConfig): ICurrentDietConfigModel => {
	const fromJSON = (currentDietConfig: ICurrentDietConfig) => {
		const { diet_id, diet_type, effective_from, kcal, last_changed_at, meal_slots_config, name } = currentDietConfig
		return {
			kcal,
			dietID: diet_id,
			dietType: diet_type,
			effectiveFrom: new Date(effective_from),
			lastChangedAt: new Date(last_changed_at),
			mealSlotsConfig: meal_slots_config ? meal_slots_config.map(CurrentDietConfigMealSlot) : [],
			name: name ? LangContentToModel(name) : null,
		}
	}

	return { ...fromJSON(json) }
}
